export const operators = [
  {value: '=', label: 'equals'},
  {value: '!=', label: 'does not equal'},
  {value: 'contains', label: 'contains'},
  {value: 'doesNotContain', label: 'does not contain'},
  {value: 'startsWith', label: 'starts with'},
  {value: 'endsWith', label: 'ends with'},
  {value: 'isNull', label: 'no value'},
];

export function getFormattedValue(field, filter) {
  if (filter.operator === '=' || filter.operator === null) {
    return filter.value;
  } else if (filter.operator === 'isNull') {
    return 'no value';
  } else {
    const operatorLabel = operators.find(o => o.value === filter.operator).label;
    return `${operatorLabel} ${filter.value}`;
  }
}

export function isValid(filter) {
  if (filter.operator === 'isNull') {
    return true;
  } else {
    return typeof filter.value === 'string'
      && filter.value.length > 0;
  }
}

export function getApiParam(field, filter) {
  switch (filter.operator) {
    case null:
    case '=':
      // It's a simple equals filter
      return filter.value;
    case '!=':
      return `not(${filter.value})`;
    case 'contains':
      return `like(${filter.value})`;
    case 'doesNotContain':
      return `unlike(${filter.value})`;
    case 'startsWith':
      return `startsWith(${filter.value})`;
    case 'endsWith':
      return `endsWith(${filter.value})`;
    case 'isNull':
      return 'is(null)';
  }

}
